var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dialog-form",
    {
      ref: "domainForm",
      attrs: {
        saveAction: _vm.saveAction,
        title: "Create Domain",
        validationPending: _vm.$v.$pending
      },
      on: { closed: _vm.resetForm }
    },
    [
      _c(
        "md-layout",
        { attrs: { "md-gutter": 16 } },
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            [
              _c("metadata-form", {
                attrs: {
                  entity: _vm.domainList,
                  "form-submitted": _vm.formSubmitted,
                  validations: _vm.$v.domainList,
                  title: ""
                }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            [
              _c("status-radio", {
                model: {
                  value: _vm.domainList.status,
                  callback: function($$v) {
                    _vm.$set(_vm.domainList, "status", $$v)
                  },
                  expression: "domainList.status"
                }
              })
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            [
              _c("md-chips", {
                class: {
                  "md-input-invalid":
                    (_vm.formSubmitted && _vm.$v.domainList.domains.$invalid) ||
                    _vm.$v.domainList.domains.$each.$invalid
                },
                attrs: {
                  "md-max": 5,
                  "md-input-placeholder": "Add domain target..."
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(chip) {
                      return [
                        _c("span", [_vm._v(_vm._s(chip.value))]),
                        !_vm.$v.domainList.domains.hasDomains
                          ? _c("span", { staticClass: "md-error" }, [
                              _vm._v("Define at least one domain")
                            ])
                          : _vm._e(),
                        _vm.$v.domainList.domains.$each.$invalid
                          ? _c("span", { staticClass: "md-error" }, [
                              _vm._v("Some of the domains has a worng format.")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.domainList.domains,
                  callback: function($$v) {
                    _vm.$set(_vm.domainList, "domains", $$v)
                  },
                  expression: "domainList.domains"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c9445cc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9445cc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/DomainFormDialog.vue
// module id = 759
// module chunks = 0